import { CoreDataSecurityMonitorsName } from './name';
import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { getCoreDataSecurityMonitorsSlice } from './get';
import { PatchDataSecurityMonitorByIdRequest } from '@api/data-security';

export const updateCoreDataSecurityMonitorsSyncSlice = createUpdateSyncSlice({
	name: CoreDataSecurityMonitorsName,
	state: getCoreDataSecurityMonitorsSlice.asyncState,
	transform: (action: PatchDataSecurityMonitorByIdRequest, state) => {
		const index = state?.results.findIndex((monitor) => monitor.id === action.id);

		if (index) {
			Object.assign(state?.results[ index ] ?? {}, action);
		}

		return {
			...state,
			results: state?.results ?? []
		};
	}
});
